import { action } from "satcheljs";

import type { OwaNovaActionUnion } from "../types";

export const onStartCallViaPhoneUrl = action("onStartCallViaPhoneUrl", event => ({
    event,
    owaType: "startCallViaPhoneUrl",
})) as OwaNovaActionUnion<"startCallViaPhoneUrl">;
